import Carousel from './v1';

export default Carousel;
